let listeChangements = [];
const urlSaveNotification = "/administration/admin-module_ville_usager/save_notifications";

function toggleCheckbox(source, moduleId) {
    let checkboxes = document.getElementsByName(moduleId);
    for (let i in checkboxes) {
        if (checkboxes[i].checked !== source.checked) {
            if (checkboxes[i].id !== undefined) {
                checkboxes[i].checked = source.checked;
                checkboxChange(checkboxes[i]);
            }
        }
    }
}

function getNotificationParMunicipalite(divToAddDatatable, user_id=undefined) {
    let data;
    if (user_id !== undefined &&  user_id!== 'current') {
        data = {
            'user_selected': user_id,
            'csrfmiddlewaretoken': csrftoken,
        };
    } else if (user_id === 'current') {
        data = {
            'csrfmiddlewaretoken': csrftoken,
        };
    } else {
        data = {
            'user_selected': $('#module_ville_select_usager').val(),
            'csrfmiddlewaretoken': csrftoken,
        };
    }
    $.ajax({
        type: "GET",
        url: "/administration/admin-module_ville_usager/notification_municipalite_usager",
        data: data,
        dataType: 'html',
        beforeSend: function (response) {
            wait.start();
        },
        success: function (response) {
            listeChangements = [];
            $(divToAddDatatable).html(response);
            initTableDatatable('#notification-dataTable', {
                sDom: 't',
                paging: false,
                bFilter: false,
                info: false,
                bLengthChange: false,
                bPaginate: false,
                destroy: false,
                searching: false,
                fixedHeader: false,
                order: [[0, 'asc']],
                language: {
                    emptyTable: "Pas de donnée de disponible"
                },
                columnDefs: [{
                    'targets': [1, 2], /* column index */
                    'orderable': false, /* true or false */
                }]
            });
            wait.stop();
        }
    });
}

function checkboxChange(checkboxElem) {
    if (listeChangements.includes(checkboxElem.id)) {
        let index = listeChangements.indexOf(checkboxElem.id);
        if (index > -1) {
            let elem_removed = listeChangements.splice(index, 1);
        }
    } else {
        listeChangements.push(checkboxElem.id);
    }
}

function save_notification(urlSave = undefined, user_id = undefined, hash = undefined, displayMsg=false) {
    if (displayMsg) {
        wait.start();
    }
    let url, data;
    if (urlSave !== undefined) {
        url = urlSave;
    } else {
        url = urlSaveNotification;
    }
    if (user_id !== undefined && hash !== undefined) {
        data = {
            'liste_notifications_a_changer': listeChangements,
            'csrfmiddlewaretoken': csrftoken,
            'hash': hash,
            'user_id': user_id
        };
    } else {
        data = {
            'liste_notifications_a_changer': listeChangements,
            'csrfmiddlewaretoken': csrftoken,
        };
    }

    $.ajax({
        type: "POST",
        url: url,
        data: data,
        success: function (response) {
            if (displayMsg) {
                infos.ajouterMessageToast({
                    message: "Les modifications ont été enregistrées avec succès.",
                    messageDuree: 5000,
                    messageCouleur: "green"
                });
            }
        },
        complete: function () {
             if (displayMsg){
                 wait.stop();
             }
        }
    });
}
